import type {
  ReleaseFeed,
  ReleaseFeedEntry,
  ReleaseReadState,
} from '@hapana/shared/schemas/release-hub'

export function readKeyOf(entry: Pick<ReleaseFeedEntry, 'id' | 'stage'>): string {
  return `${entry.id}:${entry.stage}`
}

export function unreadEntries(
  feed: ReleaseFeed | null,
  readState: ReleaseReadState | null
): ReleaseFeedEntry[] {
  if (!feed) {
    return []
  }
  const readKeys = new Set(readState?.readKeys ?? [])
  const readAllBefore = readState?.readAllBefore ?? null
  return feed.entries.filter(
    (entry) =>
      !readKeys.has(readKeyOf(entry)) && (readAllBefore === null || entry.changedAt > readAllBefore)
  )
}
